<div class="pay-step">
  @if (done()) {
    <!-- ===================== DONE (paid) ===================== -->
    <div class="paid-state">
      <i class="pi pi-check-circle"></i>
      <h3>Onboarding complete</h3>
      <p>The member is verified and marked <b>PAID</b>.</p>
      @if (paidMode()) { <p-tag [value]="'Paid via ' + paidMode()" severity="success" /> }
      <div class="wizard-actions center">
        <p-button label="Onboard New Member" icon="pi pi-user-plus" [outlined]="true" (onClick)="onboardAnother()" />
        <p-button label="Go to Dashboard" icon="pi pi-home" (onClick)="goToDashboard()" />
      </div>
    </div>
  } @else if (savedLater()) {
    <!-- ===================== DONE (pay later) ===================== -->
    <div class="paid-state later">
      <i class="pi pi-clock"></i>
      <h3>Member onboarded — Pay Later</h3>
      <p>The member is verified and saved as <b>UNPAID</b>. Collect the premium anytime from
        <b>Payments → Collect</b>; they'll also appear in your pending list.</p>
      <p-tag value="Payment pending" severity="warn" icon="pi pi-clock" />
      <div class="wizard-actions center">
        <p-button label="Collect Now" icon="pi pi-credit-card" (onClick)="collectNow()" />
        <p-button label="Onboard New Member" icon="pi pi-user-plus" [outlined]="true" (onClick)="onboardAnother()" />
        <p-button label="Go to Dashboard" icon="pi pi-home" [text]="true" (onClick)="goToDashboard()" />
      </div>
    </div>
  } @else if (summary; as s) {
    <!-- ===================== REVIEW & PAY ===================== -->
    <div class="review">
      <div class="cols">
        <!-- Member details -->
        <section class="rev-card">
          <header><i class="pi pi-user"></i> Member Details</header>
          <div class="kv-grid">
            <div><span>Full Name</span><strong>{{ s.fullName }}</strong></div>
            <div><span>Date of Birth</span><strong>{{ s.dob }}</strong></div>
            <div><span>Gender</span><strong>{{ s.gender }}</strong></div>
            <div><span>Mobile</span><strong>{{ s.mobile }}</strong></div>
            <div><span>Email</span><strong>{{ s.email }}</strong></div>
            <div><span>PAN</span><strong class="mono">{{ s.pan }}</strong></div>
            <div class="span-all"><span>Address</span><strong>{{ s.address }}</strong></div>
            @if (memberUniqueId) { <div class="span-all"><span>Member ID</span><strong class="mono">{{ memberUniqueId }}</strong></div> }
          </div>

          <div class="policy-line">
            <i class="pi pi-shield"></i>
            <span><b>{{ s.policyName }}</b> · {{ s.coverageType }} <span class="mono">({{ s.premiumCode }})</span></span>
          </div>
        </section>

        <!-- Nominees -->
        <section class="rev-card">
          <header><i class="pi pi-users"></i> Nominees <span class="muted">({{ s.nominees.length }})</span></header>
          @for (n of s.nominees; track $index) {
            <div class="nom">
              <div class="nom-top">
                <strong>{{ n.name }}</strong>
                <p-tag [value]="n.percentage + '%'" severity="info" />
              </div>
              <div class="nom-sub">
                <span>{{ n.relationship }}</span>
                <span>· DOB {{ n.dob }}</span>
                @if (n.mobile && n.mobile !== '—') { <span>· {{ n.mobile }}</span> }
              </div>
            </div>
          } @empty {
            <p class="muted">No nominees added.</p>
          }
        </section>
      </div>

      <!-- Payment breakup -->
      <section class="rev-card breakup">
        <header><i class="pi pi-calculator"></i> Payment Breakup</header>
        <div class="bk-row"><span>Base Premium</span><b>₹ {{ s.base | number: '1.0-0' }}</b></div>
        @if (s.doctor > 0) {
          <div class="bk-row"><span>Doctor / Consultant</span><b>₹ {{ s.doctor | number: '1.0-0' }}</b></div>
        }
        <div class="bk-row"><span>GST ({{ s.gstPer | number: '1.0-2' }}%)</span><b>₹ {{ s.gst | number: '1.0-0' }}</b></div>
        <div class="bk-row total"><span>Total Payable</span><b>₹ {{ s.total | number: '1.0-0' }}</b></div>
      </section>

      @if (awaitingGateway()) {
        <!-- The customer is paying in the gateway's window; this screen settles on its own when
             the payment does, so the wizard is never left looking stuck. -->
        <div class="pay-waiting">
          <i class="pi pi-spin pi-spinner"></i>
          <div>
            <strong>Waiting for the payment…</strong>
            <small>Complete it in the window that opened. This updates by itself — don't close this page.</small>
          </div>
          <p-button label="Bring window forward" icon="pi pi-external-link" size="small" [text]="true"
            (onClick)="focusGatewayWindow()" />
        </div>
      } @else if (gatewayRedirect()) {
        <!-- A redirect gateway opens in its own window, so say so before it appears. -->
        <p class="pay-note">
          <i class="pi pi-external-link"></i>
          {{ payLabel().replace('Pay with ', '') }} opens in a secure payment window. Keep this page
          open — it confirms automatically once the payment goes through.
        </p>
      }

      <!-- Offered when the gateway refuses the payment because the member has no e-mail. The
           member is already onboarded by this point, so the alternative would be abandoning a
           finished enrolment over one missing field. -->
      <app-member-email-dialog [memberId]="memberId" [memberName]="memberName"
        [gatewayName]="payLabel().replace('Pay with ', '')" (saved)="onEmailSaved($event)" />

      <div class="wizard-actions">
        <p-button label="Pay Later" icon="pi pi-clock" [outlined]="true" severity="secondary" (onClick)="payLater()" />
        <!-- Labelled with the gateway the server will actually open, not a hardcoded one. -->
        <p-button [label]="payLabel()" icon="pi pi-credit-card" iconPos="right" (onClick)="pay()"
          [loading]="processing()" />
      </div>
    </div>
  }
</div>
